import React from 'react';

import { useGATrackingForSSR } from '../../utils/gaTracking';
import { useOnClickActionForSSR } from '../../utils/onClickActionForSSR';
import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import Map from './components/Map/Map';

type TMapAppProps = {
  environment: any;
};

const MapApp = ({ environment }: TMapAppProps) => {
  useGATrackingForSSR();
  useOnClickActionForSSR();

  const { initialMapCenter, postcode: initialPostcode, distance: initialRadius } = environment;

  return (
    <EnvironmentProvider value={environment}>
      <Map initialMapCenter={initialMapCenter} initialPostcode={initialPostcode} initialRadius={initialRadius} />
    </EnvironmentProvider>
  );
};

export default MapApp;
